import { crafterBasicExampleData1, crafterBasicExampleData2 } from './crafter-basic.node.test-data'

export const crafterBasicListExampleData1 = {
  [crafterBasicExampleData1.id]: crafterBasicExampleData1,
  [crafterBasicExampleData2.id]: crafterBasicExampleData2
}